export default "__VITE_ASSET__BHSNvc3K__"